// @flow

import loadByHashid, {
  type LoadByHashidInjectedProps,
} from 'app/general/loadByHashid';
import {type LoadVersionsInjectedProps} from 'app/general/loadVersions';

import {DetailLoadingPage} from 'app/general/loading/DetailLoadingPage';
import {getPolicyByHashid} from './actions';

export type {LoadByHashidInjectedProps, LoadVersionsInjectedProps};

export const loadPolicyByHashid = loadByHashid(
  (policy) => getPolicyByHashid(policy.hashid),
  ['policiesArea', ['policies', 'byId']],
  DetailLoadingPage
);
